import { useCallback, useContext, useEffect } from 'react';
import AnalyticsContext from '../context/analytics';
import PayProgramContext from '../context/payProgram';
import GoogleTagManager from '../../lib/utils/gtm';

// TODO: Once GTM lives within useAnalytics, trackEvent and trackPageView will not need to be re-specified here
export default function useTracking(autoTrackScreenName) {
  const analytics = useContext(AnalyticsContext);
  const payProgramMetadata = useContext(PayProgramContext);
  const { payProgram, variant } = payProgramMetadata || {};

  const trackEvent = useCallback((eventName, attributes) => {
    analytics.tagEvent({ name: eventName, attributes });
    GoogleTagManager.event({
      event: eventName,
      attributes,
    });
  }, [analytics]);

  const trackPageView = useCallback((screenName, attributes) => {
    if (attributes && variant) {
      attributes.Enrollment_Variant = variant;
    }
    analytics.tagPageView({ name: screenName, attributes });
    GoogleTagManager.event({
      event: `${screenName}_Opened`,
      ...attributes,
    });
  }, [variant, analytics]);

  useEffect(() => {
    if (autoTrackScreenName) {
      const attributes = {};

      if (payProgram) {
        attributes.Pay_Program = payProgram;
      }
      if (variant) {
        attributes.Enrollment_Variant = variant;
      }

      trackPageView(autoTrackScreenName, attributes);
    }
  }, [autoTrackScreenName, payProgram, trackPageView, variant]);

  return { analytics, trackEvent, trackPageView };
}
